import styled from "styled-components";
import { Box } from "@pochta/ui";
var BannerPlace = styled(Box).withConfig({
  displayName: "BannerPlace",
  componentId: "sc-1ka8b2z-0"
})(["width:100%;overflow:hidden;a{display:block;}img{width:100%;height:100%;object-fit:contain;}"]);
export default BannerPlace;